module.exports = __webpack_public_path__ + "static/blog31-2ec782c6ebd1969913d43945c5afa7c8.png";